import { useEffect } from "react";
import axios from "axios";
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./login.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import Chatbot from "../../components/v2/chatbot";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa6";


function Login() {
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [loginError, setLoginError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const { email, password } = loginData;
    const newErrors = {};

    if (!password) {
      newErrors.password = "Veuillez remplir le champ mot de passe";
    }

    if (!email) {
      newErrors.email = "Veuillez remplir le champ email";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      // Envoyer les données de connexion au backend
      setLoginError("");
      const response = await axios.post(
        "/api/users/login",
        loginData,
        {
          withCredentials: true,
        }
      );
      setCurrentUser(response.data);
      window.location.href = "/dashboard";
    } catch (error) {
      setLoginError(true)
    }
  };
  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <React.Fragment>
      <div className="login">
        <Navbar />
        <Chatbot />
        <div className="div-main">
          <div className="div-main21">
            <div className="top-div mt-44">
              <div className="left">
                <span className="text">
                  {" "}
                  <span>
                    <FontAwesomeIcon icon={faCheck} className="red-pi-check" />
                  </span>{" "}
                  DISTRIBUTION GRATUITE
                </span>
                <span className="text">
                  <span>
                    <FontAwesomeIcon icon={faCheck} className="red-pi-check" />
                  </span>{" "}
                  MISE EN LIGNE RAPIDE
                </span>
              </div>
              <div className="right">
                <span className="text">
                  <span>
                    <FontAwesomeIcon icon={faCheck} className="red-pi-check" />
                  </span>{" "}
                  DONNÉES EN TEMPS RÉELS
                </span>
                <span className="text">
                  <span>
                    <FontAwesomeIcon icon={faCheck} className="red-pi-check" />
                  </span>{" "}
                  SERVICE CLIENT EFFICACE
                </span>
              </div>
            </div>
            <div className="centered-div">
              <div className="bg-form-bg px-[35px] py-20 md:w-1/2 w-full" >
              {
                loginError
                  ? <div style={{color:'red', textAlign:'center'}}>Email ou mot de passe incorrect</div>
                  :null
              }
                <input
                  type="email"
                  placeholder="Adresse email"
                  value={loginData.email}
                  onChange={handleInputChange}
                  name="email"
                  className="w-full h-[45px] bg-input-bg rounded-lg px-3 outline-none"
                />
                  {errors.email && (
                    <span className="text-red-500">{errors.email}</span>
                  )}
                  <div className="w-full flex justify-between items-center bg-input-bg rounded-lg h-[45px] px-3 mt-4">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Mot de passe"
                      value={loginData.password}
                      onChange={handleInputChange}
                      name="password"
                      className="w-[90%] h-full bg-transparent rounded-lg outline-none"
                    />
                    {
                      showPassword
                        ? <FaRegEye onClick={handleShowPassword} />
                        : <FaRegEyeSlash onClick={handleShowPassword} />
                    }
                  </div>
                  {errors.password && (
                    <span className="text-red-500">{errors.password}</span>
                  )}

                <div className="w-full flex justify-between items-center mt-4">
                  <button className="bg-red-500 h-[45px] font-bold rounded-lg text-white w-32 " onClick={handleLogin}>
                    Se connecter
                  </button>
                  <NavLink to='/forgotPassword' className="text-white font-bold underline text-xs md:text-lg">Mot de passe oublié</NavLink>
                </div>
                <div className="text-white text-xs md:text-lg">
                  Vous n'avez pas de compte ?{" "}
                  <Link to="/signup" className="text-blue-700 underline">
                    Créer un compte
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      
    </React.Fragment>
  );
}

export default Login;
